import { defineStore } from "pinia";

export const useGlobalStore = defineStore("globalStore", {
  state: () => {
    return {
      navigation: <any>null,
      footer: <any>null,
      global: <any>null,
      list: [],
      mounted: false,
      canTouch: false,
      scrolling: false,
      mouseDown: false,
      touching: false,
    };
  },
  getters: {
    navigationItems: (state: any) => {
      return state.navigation?.data[0];
    },
    footerLinksCol1: (state: any) => {
      return state.footer?.data[0]?.linksCol1;
    },
    footerLinksCol2: (state: any) => {
      return state.footer?.data[0]?.linksCol2;
    },
    footerLinksCol3: (state: any) => {
      return state.footer?.data[0]?.linksCol3;
    },
    wysiwyg: (state: any) => {
      return state.footer?.data[0]?.wysiwyg;
    },
    snow: (state: any) => {
      return state.global?.data[0]?.snow;
    },
    isScrolling: (state: any) => {
      return state.scrolling || state.mouseDown || state.touching;
    },
  },
  actions: {
    isMounted() {
      this.mounted = true;
    },
    scrollingStarted() {
      this.scrolling = true;
    },
    scrollingEnded() {
      this.scrolling = false;
    },
    setMouseUp() {
      this.mouseDown = false;
    },
    setMouseDown() {
      this.mouseDown = true;
    },
    touchStart() {
      this.touching = true;
    },
    touchEnd() {
      this.touching = false;
    },
    hasTouch() {
      this.canTouch = false;
    },
  },
});
